module.exports = __webpack_public_path__ + "img/applicationConstruction-sjywlz.1e3e88ac.png";